<div class="fr-page-content fr-page-content--fullCenter">
  <fr-error-base>
    <span title>400 Bad request</span>
    <span description>There was a bad request and the action can't be completed.</span>
    <span url>URL: {{ errorUrl }}</span>
  </fr-error-base>
</div>
